import script from "./MessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=0d300761&lang=css"

const __exports__ = script;

export default __exports__